mutation RemoveMetadataField($fieldId: ID!) {
    removeMetadataField(fieldId: $fieldId)
}
